export const authRoutes = []
